<template>
  <div class="main-container">

    <div class="management">
      <h1>{{ t('contentsMain.CONTENTS') }}</h1>
      <div class="tabs">
        <div :class="{ '--selected': route.path.toLowerCase().includes('mastercourses') }"
          @click.stop="router.replace('/contents/mastercourses')">{{ t('contentsMain.MASTER_COURSES') }}</div>
        <div class="disabled">{{ t('contentsMain.RESOURCES') }}</div>
        <!-- <div :class="{ '--selected': route.path.includes('courses') }" @click.stop="router.replace('/management/courses')">
          Cursos</div> -->
      </div>
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const route = useRoute();
const router = useRouter();
const store = useStore()
const user = computed(() => store.getters.manageUser_user);
const { t } = useI18n();

onMounted(() => {
  if (!user.value.permissions.includes('ACCESO_CONTENIDO')) router.push('/')
})
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.disabled{
  opacity: .6;
  cursor: default !important;
}

.main-container {
  padding: 8px;
  background: #fff;
  min-height: 90vh;

  .management {
    width: 100%;
    max-width: 1116px;
    margin: 0 auto;
    padding: 36px 0;

    h1 {
      font-size: 25px;
      font-weight: 700;
    }

    .tabs {
      display: flex;
      margin: 30px 0;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);

      >div {
        height: 60px;
        width: 180px;
        @include flex-column;
        justify-content: center;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;

        &.--selected {
          color: $green;
          border-bottom: 2px solid $green;
          cursor: default;
        }
      }
    }
  }
}</style>